<template>
  <div>
    <template v-if="isShippingNotice">
    <div class="shipping-notice checkout" >
      <h4>Hinweis zur Zustellung:</h4>
      <p v-html="$translate('KrauseSohn::Template.shippingNotice')"></p>
    </div>
    </template>
    <template v-if="isSilvester">
    <div class="shipping-notice checkout" >
      <h4>Hinweis zur Zustellung:</h4>
      <p v-html="$translate('KrauseSohn::Template.silvesterNotice')"></p>
    </div>
    </template>
    <template v-if="isSofort">
    <div class="shipping-notice checkout" >
      <h4>Hinweis zur Zahlungsart:</h4>
      <p v-html="$translate('KrauseSohn::Template.sofortNotice')"></p>
    </div>
    </template>
    <template v-if="isFireworkInBasket && showFireworkNote">
        <div class="shipping-notice checkout" >
        <h4>Hinweis für Feuerwerk Kategorie 2:</h4>
        <p v-html="$translate('KrauseSohn::Template.fireworkNotice')"></p>
          <div v-if="isBasketBelow">
            Beachten Sie bitte das der Mindestwarenwert für den Feuerwerkversand bei {{  getMinShippingAmount }} € liegt.
          </div>
        </div>
    </template>
    <template v-if="isBadPlz">
      <div class="shipping-notice checkout" >
        <h4>Kein Versand Möglich!</h4>
        <p>Der Versand in das gewählte Postleitzahl-Gebiet ist mit diesem Versanddienstleister leider nicht möglich!</p>
      </div>
    </template>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {

    name: "shipping-notice",

    computed:
    {
      isBadPlz()
      {
        const plzArray = [
          "18565", "25845", "25849", "25859", "25863", "25869", "25938", "25946", "25980", "25992", "25996", "26465",
          "26474", "26486", "26548", "26571", "26579", "26757", "27498", "27499", "28266", "83209", "83256"
        ];

        let isBill = false;

        let isDelivery = false;
        // For Live a negative check for 109 and 110
        /* eslint-disable */

        if (this.needPlzCheck())
        {
          if (this.$store.state.address.billingAddress)
          {
            if (this.checkAddressType(plzArray, this.billingAddressPlz))
            {
              isBill = true;
            }
            if (this.deliveryAddressPlz !== undefined)
            {
              if (this.checkAddressType(plzArray, this.deliveryAddressPlz))
              {
                isDelivery = true;
              }
            }
            if ((isBill && this.deliveryAddressPlz === undefined) ||
                (!isBill && isDelivery) || (isBill && isDelivery))
            {
              this.$store.commit("setDisablePlaceOrderAddress", true);
              return true;
            }
            else
            {
              this.$store.commit("setDisablePlaceOrderAddress", false);
            }
          }
        }
        /* eslint-enable */
        return false;
      },

      ...mapState({
            shippingProfileId: state => state.checkout.shipping.shippingProfileId,
            basketItems: state => state.basket.items,
            basket: state => state.basket.data,
            shippingPrivacyHintAccepted: state => state.checkout.shippingPrivacyHintAccepted,
            billingAddressPlz: state => state.address.billingAddress.postalCode,
            deliveryAddressPlz: state => state.address.deliveryAddress.postalCode,
            parcelServiceId: state => state.checkout.shipping.selectedShippingProfile.parcelServiceId
        }),
          getMinShippingAmount()
          {
            return App.configKS.checkout.minValueForShipping;
          },

         isBasketBelow()
         {
            if (this.isFireworkInBasket && (parseInt(App.configKS.checkout.minValueForShipping) > this.basket.itemSum))
            {
              return true
            }
            return false;
         },
        /**
         * Group Id 3 - Feuerwerk
         * Selection Id 5 - Mit Genehmigung
         * Property Id 4 - Genehmigung
         */
        isFireworkInBasket()
        {
            let check = false;
            if (this.basketItems.length > 0)
            {
                this.basketItems.forEach(item => {
                    if (item.variation.data.variationProperties && item.variation.data.variationProperties.length)
                    {
                        let vProperties =  item.variation.data.variationProperties;
                        vProperties.forEach(propertyGroup => {
                            if(propertyGroup.id == 3){
                              propertyGroup.properties.forEach(property => {
                                if (property.id == 4)
                                {
                                  if (property.values.selectionId == 5)
                                  {
                                    check = true;
                                  }
                                }
                              });
                            }
                         });
                    }
                });
            }
            return check;
        },


        showFireworkNote()
        {
            return  App.configKS.checkout.showFireworkNote;
        },

        shipping(){
          return App.configKS.checkout.shippingSpeditionPrivat;
        },

        silvester(){
          return App.configKS.checkout.shippingSpeditionSilvester;
        },
        idSofort(){
          return App.configKS.checkout.idSofortPlugin;
        },
        isShippingNotice()
        {
            if (this.showShippingNotice() && !(this.isCompany()))
            {
                return true;
            }
            else
            {
                return false;
            }
        },
        isSilvester()
        {

            if (this.shippingProfileId == this.silvester)
            {
                return true;
            }
            return false;
        },
        isSofort()
        {
            if (this.$store.state.checkout.payment.methodOfPaymentId == this.idSofort)
            {
                return true;
            }
            return false;
        }
    },
    methods:
    {
        needPlzCheck()
        {
          let result;

          switch (this.parcelServiceId)
          {
          case 104: result = false; break;
          case 109: result = false; break;
          case 110: result = false; break;
          default:
            result = true;
            break;
          }
          return result;
        },
        checkAddressType(plzArray, addressType)
        {
          for (let i = 0; i < plzArray.length; i++)
          {
            if (addressType.search(plzArray[i]) != -1)
            {
              return true;
            }
          }
          return false;
        },

        showShippingNotice()
        {
            if (this.shippingProfileId == this.shipping)
            {
                return true;
            }
            return false;
        },
        isCompany()
        {
            let isCompany = false;
            if (!this.$store.state.checkout.readOnly)
            {
                 if (this.$store.state.address.billingAddress && this.$store.state.address.billingAddress.gender === "company")
            {
                if ((this.$store.state.address.billingAddress.name1 != null) && (this.$store.state.address.billingAddress.name1.length != "Privat"))
                {
                    isCompany = true;
                }

            }
            if (this.$store.state.address.deliveryAddress && this.$store.state.address.deliveryAddress.gender === "company")
            {
                if ((this.$store.state.address.deliveryAddress.name1 != null) && (this.$store.state.address.deliveryAddress.name1.length != "Privat"))
                {
                    isCompany = true;
                }
            }
            return isCompany;
            }
        }
    }
}
</script>
